import { render } from "./Group.vue?vue&type=template&id=5374cc9b&scoped=true&ts=true"
import script from "./Group.vue?vue&type=script&lang=ts"
export * from "./Group.vue?vue&type=script&lang=ts"

import "./Group.vue?vue&type=style&index=0&id=5374cc9b&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5374cc9b"]])

export default __exports__